import { CodeViewer, Flex, Typography } from "djuno-design";
import { Link } from "react-router-dom";
import { themeChangersPageUrl } from "../urls";

const { Title, Text } = Typography;

const DDPPage = () => {
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Flex direction="col">
        <Flex direction="col">
          <Title level={4}>DjunoDesignProvider</Title>
          <Title level={5}>Overview</Title>
          <Text size="sm" style={{ marginBottom: 30 }}>
            The{" "}
            <Text size="xs" code strong>
              DjunoDesignProvider
            </Text>{" "}
            and{" "}
            <Text size="xs" code strong>
              useDjunoDesign
            </Text>{" "}
            hook are foundational elements for managing and accessing the theme
            within the Djuno Design system. They provide an easy way to access
            theme-related data and ensure that your components stay consistent
            with the design guidelines across your application. look at the{" "}
            <Typography.Link size="sm">
              <Link to={themeChangersPageUrl}>ThemeChanger</Link>
            </Typography.Link>{" "}
            component
          </Text>
          <Title level={5}>DjunoDesignProvider</Title>
          <Text size="sm">
            This provider component sets up a context that allows all nested
            components to access theme settings via the{" "}
            <Text size="xs" code strong>
              useDjunoDesign
            </Text>{" "}
            hook. It wraps the application (or specific parts of it) to ensure
            the theme is accessible where needed.
          </Text>
          <Title level={5} className="mt-4">
            useDjunoDesign Hook
          </Title>
          <Text size="sm">
            The{" "}
            <Text size="xs" code strong>
              useDjunoDesign
            </Text>{" "}
            hook allows components to access the theme provided by{" "}
            <Text size="xs" code strong>
              DjunoDesignProvider
            </Text>
            . It ensures that the theme context is available and provides
            fallback logic in case the provider is not set.
          </Text>
          <Title level={5} className="mt-6">
            Usage
          </Title>
          <Title level={6}>DjunoDesignProvider</Title>
          <Text size="sm" className="mb-2">
            Wrap your application or component tree with the{" "}
            <Text size="xs" code strong>
              DjunoDesignProvider
            </Text>
            to make the theme accessible via{" "}
            <Text size="xs" code strong>
              useDjunoDesign
            </Text>
          </Text>
          <CodeViewer
            showLineNumbers
            theme="dark"
            copyable
            fontSize="0.8rem"
            code={`import { DjunoDesignProvider } from 'djuno-design';

const App = () => {
  return (
    <DjunoDesignProvider>
      <YourAppComponents />
    </DjunoDesignProvider>
  );
}`}
          />
          <Title level={6} className="mt-5">
            useDjunoDesign Hook
          </Title>
          <Text size="sm" className="mb-2">
            Use the{" "}
            <Text size="xs" code strong>
              useDjunoDesign
            </Text>{" "}
            hook inside any component to access the theme.
          </Text>
          <CodeViewer
            showLineNumbers
            theme="dark"
            copyable
            fontSize="0.8rem"
            code={`import { useDjunoDesign } from 'djuno-design';

const ThemedComponent = () => {
  const { theme } = useDjunoDesign();

  return (
    <div style={{ background: theme.background }}>
      Themed content
    </div>
  );
};`}
          />
        </Flex>
      </Flex>
    </div>
  );
};

export default DDPPage;
